<template>
  <div
    class="quick-selection__item"
    draggable="true"
    @dragstart.stop="dragstart"
    @dragend.stop="dragend"
  >
    {{ element.name }}
    <span
      class="ml-1 mt-1"
      style="cursor: pointer;"
      @click="$emit('delete')"
    >
      &times;
    </span>
  </div>
</template>

<script>
export default {
  props: {
    element: {
      type: Object,
      required: true,
    },
  },

  methods: {
    dragstart (e) {
      this.$emit('dragstart')
    },

    dragend () {
      this.$emit('dragstop')
    },
  },
}
</script>
